import { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from "react-router-dom";
import * as rolesActions from "store/entities/settingsInfo/action";
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import { ReactComponent as IconExclamationCircle } from "assets/images/icons/project-icons/information.svg";
import iconPlus from "assets/images/icons/project-icons/Plus.svg";
import useInlinePageRouter from "components/__new/general/useInlinePageRouter";
import SearchBox from "components/__new/common/SearchBox";
import Table from "components/__new/common/Table";
import DropdownNew from "utils/dropdown";
import Pagination from "components/__new/common/pagination";
import FormDrawer from "components/__new/common/form-drawer";
import CustomRoleModal from 'components/__new/common/form/CustomRoleModal';
import EditRoleModal from "components/__new/common/form/EditRoleModal";
import EditRolePermissionsModal from 'components/__new/common/form/EditRolePermissionsModal';
import ViewUserRoleModal from "components/__new/common/form/ViewUserRoleModal";
import ViewRoleModal from "components/__new/common/form/ViewRolePermission";
import DeleteRoleModal from "components/__new/common/form/DeleteRole";
import { TableContent } from "components/__new/common/TableContent";
import IconEmptyBox from "assets/images/icons/project-icons/empty-box.png";
import useLoginInfo from "hooks/useLoginInfo";
import processParams from "utils/processParams";
import useUrlQueryParams from "hooks/useUrlQueryParams";
import ContentLoading from "components/__new/common/ContentLoading";
import pluralize from "utils/pluralize";


const Roles = () => {
    const {userInfo} = useLoginInfo()
    const location = useLocation();
    const {urlQueryParams} = useUrlQueryParams();
    const {employerId} = userInfo?.company
    const dispatch = useDispatch() 
    const { getRoles, getRolesLoading, rolePermission, rolePermissionLoading } = useSelector(state => state.entities.settingsInfo)
    
    const [listParams, setListParams] = useState({page: 1, limit: 20, employerId})
    const [isOpenViewUsers, setIsOpenViewUsers] = useState(false);
    const { InlineRouterTab } = useInlinePageRouter();
    const [isOpenCustomRole, setIsOpenCustomRole] = useState(false);
    const [allowEditRoleModal, setAllowEditRoleModal] = useState(false);
    const [showUserRoleList, setShowUserRoleList] = useState(false);
    const [allowViewRoleModal, setAllowViewRoleModal] = useState(false);
    const [showDeleteRoleModal, setShowDeleteRoleModal] = useState(false);
    const [roles, setRoles] = useState([])
    const [users, setUsers] = useState([])
    const [deleteId, setDeleteId] = useState(null)
    const [isRolePermissionsActive, setIsRolePermissionsActive] = useState(false)

    // function countUsersByRole(data=[], roleName) {
    //     return data?.filter(item => item.name === roleName).length;
    // }
    

    
    const queryOptions = [
        {
            title: "Profile Information",
            path: "/settings/profile"
            
        },
        {
            title: "Company Details",
            path: "/settings/info"           
        },
        {
            title: "Teams",
            path: "/settings/team-management",
            
        },
        {
            title: "Role Management",
            path: "/settings/team-management/roles",
            
        },
        {
            title: "On-Demand Pay",
            path: "/settings/ondemand-pay",
            
        },
        {
            title: "Login & Security",
            path: "/settings/login-security",
           
        },
        // {
        //     title: "Notifications",
        //     path: "/settings/notifications",
           
        // },
    ]
    
    const getAllRoles = () => { 
        // let params = {...listParams};
        let params = {...listParams, employerId};

        // params = processParams(urlQueryParams, params, "role", "string", "", "role");
        // params = processParams(urlQueryParams, params, "status", "string", "", "status");
        params = processParams(urlQueryParams, params, "search", "string", "", "search");
        
        setListParams(params);
        dispatch(rolesActions.getAllRoles(params));  
    }
     
    const getCurrentRolePermission = (id) => {
    dispatch(rolesActions.getRolePermission(id))
    }
    
   const handleEditRole = (rls) => {
    setRoles(rls)
    getCurrentRolePermission(rls?.id)
    setAllowEditRoleModal(true)
   }
   
   const handleUsersInRole = (users) => {
    setUsers(users)
    setShowUserRoleList(true)
   }
   
   const handleRolePermission = (rls) => {
    setRoles(rls)
    getCurrentRolePermission(rls?.id)
    setAllowViewRoleModal(true)
   }

   const handleDeleteRole = (id) => {
    setDeleteId(id)
    setShowDeleteRoleModal(!showDeleteRoleModal)
   }
    
    // const numberOfRoles = getRoles?.data?.totalDocs ?? 0;
    const numberOfRoles = getRoles?.data?.totalDocs;
    

    
    useEffect(() => {
        getAllRoles();
    }, [location]);
    
    
    
    return ( 
        <div>


            <DynamicHeadTag
                headerText="Roles | Team Management | Settings"
                headerDescription="Customize your account preferences, including account information, security and privacy settings, notifications, and other account-related options."
            />

            <ViewUsers
                isOpen={isOpenViewUsers}
                setIsOpen={setIsOpenViewUsers}
            />

            <CustomRoleModal 
                isOpen={isOpenCustomRole}
                setIsOpen={setIsOpenCustomRole}
                getAllRoles={getAllRoles}
            />
            
            <EditRoleModal 
                isOpen={allowEditRoleModal}
                setIsOpen={setAllowEditRoleModal}
                data={rolePermission}
                getAllRoles={getAllRoles}
                roles={roles}
            />
            
            <EditRolePermissionsModal 
                isOpen={isRolePermissionsActive}
                setIsOpen={setIsRolePermissionsActive}
                data={roles}
            />
            
            <ViewUserRoleModal 
                isOpen={showUserRoleList}
                setIsOpen={setShowUserRoleList}
                data={users}
            />

            <ViewRoleModal 
                isOpen={allowViewRoleModal}
                setIsOpen={setAllowViewRoleModal}
                data={rolePermission?.data}
                rolePermissionLoading={rolePermissionLoading}
            />
            
            <DeleteRoleModal 
                isOpen={showDeleteRoleModal}
                setIsOpen={setShowDeleteRoleModal}
                data={deleteId}
                getAllRoles={getAllRoles}
            />

            <div className="lg:flex">
                <div className="w-full lg:w-1/2">
                    <div className="page-title text-ep-deep-dark">
                        Settings
                    </div>
                </div>
            </div>
            
            <div className="mt-6 w-full">
                <InlineRouterTab
                    items={queryOptions}
                />
            </div>

            <div className="mt-6 lg:flex items-start lg:space-x-6">
                <div  className="mt-6 p-4 sm:p-6 bg-white lg:mt-0 lg:flex-grow" style={{borderRadius: '12px'}}>
                    <div className="w-full lg:w-1/2 ">
                        {/* <div className=" flex items-center">
                            <div className="page-title pr-2">
                                Role Management
                            </div>
                            {
                            getRolesLoading === false && <div className="p-1 px-2 border border-none rounded-3xl bg-ep-primary-100 text-ep-primary-600 font-medium">
                                {getRolesLoading === false && (numberOfRoles > 1 ? (numberOfRoles + ' roles') : (numberOfRoles + ' role'))}
                            </div>
                            }
                        </div> */}
                        <div className="flex items-center justify-start w-max">
                            <h3 style={{ fontSize: '18px', lineHeight: '28px' }} className="font-bold leading-7 text-lg text-ep-black pr-2">Role Management</h3>
                            <p className="font-medium label h-6 text-sm text-ep-primary-600 " style={{background: '#00535C14'}}>
                                <ContentLoading
                                    loading={getRolesLoading}
                                    data={<>{numberOfRoles ?? (" " || "-")} {pluralize(numberOfRoles, "role", "roles")}</>}
                                />
                            </p>
                        </div>
                    </div>

                    <div className="mt-6 lg:flex justify-between">
                        <div className="max-w-sm flex-grow sm:mr-6">
                            <SearchBox placeholder="Search Role Name" name="search" extraUrlParams="page=1" />
                        </div>
                        <div className="w-full lg:w-1/2 flex mt-2 lg:mt-0 lg:justify-end space-x-3 items-center">
                            <button onClick={() => setIsOpenCustomRole(true)} className="btn btn-ep-primary md:btn-lg">
                            <img src={iconPlus} alt="iconPlus" className="w-3 h-3 mr-2 inline" />
                                <span style={{fontWeight: 500, fontSize: '14px', lineHeight: '20px'}}>Create custom role</span>
                            </button>
                        </div>
                    </div>
                    

                    <div className="p-4 sm:p-6">

                    </div>
                    
                    <div>
                        <Table className="w-full">
                            <Table.Head>
                                <th style={{ fontSize: '16px', lineHeight: '18px', fontWeight: 500 }} className=" text-ep-gray-600">Role Name</th>
                                <th style={{ fontSize: '16px', lineHeight: '18px', fontWeight: 500 }} className=" text-ep-gray-600">Description</th>
                                <th style={{ fontSize: '16px', lineHeight: '18px', fontWeight: 500 }} className=" text-ep-gray-600">Associated Users</th>
                                <th></th>
                            </Table.Head>
                            <Table.Body>
                            <TableContent
                                    loading={getRolesLoading}
                                    loadingText="Loading roles list"
                                    data={getRoles?.data?.data}
                                    colspan={6}
                                    emptyUI={<>
                                        <div className="py-20 mx-auto text-center text-base">
                                            <div className="flex justify-center">
                                                <img src={IconEmptyBox} alt="Empty" className="h-48" />
                                            </div>
                                            <div className="text-[#101828] font-medium">
                                                No Data Available Yet
                                            </div>
                                            <div className="mt-1 text-[#4A5564]">
                                                Once available, it will appear here
                                            </div>
                                        </div>
                                    </>}
                                />
                                {
                                    getRolesLoading === false && getRoles?.data?.data?.map(role => (
                                        <tr key={role.id}>
                                            <td>
                                                <div style={{fontWeight: 500, fontSize: '14px', lineHeight: '20px', letterSpacing: '1%', width: '221px',}} className='text-ep-black '>
                                                    {role.name?.toLowerCase() === "hr admin" ? "HR" : role.name}
                                                </div>
                                            </td>
                                            <td>
                                                <div className="text-[#667085]" style={{maxWidth: '506px',
                                                    whiteSpace: 'normal'
                                                }} >
                                                    {role.description}
                                                </div>
                                            </td>
                                            <td>
                                                <div className="text-[#667085]">
                                                    <span className="text-ep-primary font-bold">{role?.businessMember?.length}</span> {role?.businessMember?.length > 1 ? ' Users' : ' User'}
                                                </div>
                                            </td>
                                            <td>
                                                <div>
                                                    <DropdownNew flipSwitch={true}>
                                                        <></>
                                                        <div>
                                                            {!(role?.name?.toLowerCase() === 'owner' || role?.name?.toLowerCase() === 'hr admin' || role?.name?.toLowerCase() === 'finance admin') &&
                                                                <div className="dropdown-item dropdown-item-icon flex" style={{"flexWrap": "nowrap"}}>    
                                                                <div onClick={()=> handleEditRole(role)} className="flex-wrap flex-grow" style={{whiteSpace: "normal"}}>
                                                                    Edit Role
                                                                </div>
                                                            </div>}
                                                            <div onClick={() => handleUsersInRole(role.businessMember)} className="dropdown-item dropdown-item-icon">
                                                                View Users in Role
                                                            </div>
                                                            <div onClick={() => handleRolePermission(role)} className="dropdown-item dropdown-item-icon">
                                                                View Role Permissions
                                                            </div>
                                                           {!(role?.name?.toLowerCase() === 'owner') && 
                                                           <div onClick={() => handleDeleteRole(role.id)} className="dropdown-item dropdown-item-icon text-red-500">
                                                                Delete Role
                                                            </div>}
                                                        </div>
                                                    </DropdownNew>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                }
                                
                               
                            </Table.Body>
                        </Table>
                    </div>
                    
                    <div className="mt-6">
                        <Pagination data={getRoles?.data} />
                    </div>
                </div>
            </div>


        </div>
    )
}


const ViewUsers = (props) => {
    const {isOpen, setIsOpen} = props;
    
    
    return (
        <FormDrawer display="center" size="lg" isOpen={isOpen} setIsOpen={setIsOpen}>
            <div className="p-8">
                <div className="font-dm-sans font-bold text-[#0D0C2B] text-lg sm:text-xl">
                    View Users
                </div>

                <div className="mt-8">

                    <div className="alert">
                        <div>
                            <IconExclamationCircle className="w-5" />
                        </div>
                        <div className="text-sm">
                            This team members has a Full access to all permission modules    and it is not editable
                        </div>
                    </div>

                    <div className="mt-6 border-t border-gray-200">
                        {[...Array(4)]?.map((user, index) =>
                            <div key={index} className="px-3 py-5 flex justify-between space-x-3 border-b border-gray-200">
                                <div className="text-ep-primary">
                                    Nwachukwu Soyemi
                                </div>
                                <div className="text-fade">
                                    oladele@earnipay.com
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="mt-12 flex space-x-3 justify-start">
                        <button type="button" onClick={() => setIsOpen(false)} className="btn btn-transparent-primary">
                            Close
                        </button>
                    </div>
                </div>
                
            </div>
        </FormDrawer>
    )
}


export default Roles;
